import { Suspense, lazy } from "react";
import Loader from "../../customs/loader/main";


const Main = lazy (
  () => import("../../components/reports/candidateReport/main")
);

const NomineeReport = () => {
  return (
    // <Layout>
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
    // </Layout>
  );
};

export default NomineeReport;
